import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser'

@Component({
  selector: 'app-a-pointofsale-window',
  templateUrl: './a-pointofsale-window.component.html',
  styleUrls: ['./a-pointofsale-window.component.css']
})
export class APointofsaleWindowComponent implements OnInit {

  constructor(private titleService: Title) { }

  ngOnInit() {
    this.titleService.setTitle('/pos');
  }

}
